import "./index.css";
import React from "react";

export default function ProductBanner({ product }) {
  const getLabelandClass = () => {
    const isDigital = product.productType.value === "digital";
    const productName = product.caption.toLowerCase();
    const isDemo = productName.includes("demo product");

    if (isDemo)
      return { label: "Demo Product", className: "product-banner__demo" };

    if (isDigital)
      return { label: "Token Product", className: "product-banner__token" };

    return { label: "", className: "" };
  };

  const { label, className } = getLabelandClass();
  return (
    label.length > 0 && (
      <div className={`product-banner ${className}`}>{label}</div>
    )
  );
}



// WEBPACK FOOTER //
// ./src/components/Package/components/ProductBanner/index.js